export type PrivateIncentiveModalResource = {
  lastName: string;
  vin: string;
  isLeaseBuyOut: boolean;
  leadId: string;
  legacyDealerId: string;
  privateIncentiveLookupActionType: string;
  leadDealerId: string;
};

export enum PrivateIncentiveActionType {
  None = 'None', // this is for none
  PrivateIncentiveLookupLoyaltyDashboardServiceCustomer = 'PrivateIncentiveLookupLoyaltyDashboardServiceCustomer', // loyalty dashboard PI and isConquest true
  PrivateIncentiveLookupLoyaltyDashboardLoyaltyCustomer = 'PrivateIncentiveLookupLoyaltyDashboardLoyaltyCustomer', // loyalty dashboard PI and isConquest false
  PrivateIncentiveLookupConquestDashboardConquestCustomer = 'PrivateIncentiveLookupConquestDashboardConquestCustomer', // Conquest dashboard PI true // which amit added
  PrivateIncentiveLookupServiceDashboardLoyaltyCustomer = 'PrivateIncentiveLookupServiceDashboardLoyaltyCustomer', // Service Dashbaord with PI true
  PrivateIncentiveLookupServiceDashboardActivatedCustomer = 'PrivateIncentiveLookupServiceDashboardActivatedCustomer', // Service Dashboard with PI and Active customer
  PrivateIncentiveLookupServiceDashboardNonActivatedCustomer = 'PrivateIncentiveLookupServiceDashboardNonActivatedCustomer', // Service Dashbaord with PI and non active customer
  PrivateIncentiveLookupConquestSearch = 'PrivateIncentiveLookupConquestSearch', // PIL with 9 digit reedamption conquest search,
  PrivateIncentiveFlipCardLoyaltyCustomer = 'PrivateIncentiveFlipCardLoyaltyCustomer', // Mastermind dealsheet private incentive flip card for loyalty customer
  PrivateIncentiveFlipCardServiceCustomer = 'PrivateIncentiveFlipCardServiceCustomer', // Mastermind dealsheet private incentive flip card for service customer
  IncentiveAdvantagePrivateIncentiveFlipCardLoyaltyCustomer = 'IncentiveAdvantagePrivateIncentiveFlipCardLoyaltyCustomer', // Incentive Advantage dealsheet private incentive flip card for loyalty customer
}
